import React from "react";

/**
 * Class to add a default attribute to define the source of the data (Single or Dual band context)
 */
export default class WLDInputComponent extends React.Component<any, any> {

    /**
     * @param props list of component parameters :
     * - band is the number of band (simple = 1 / dual = 2) ;
     * - bandItem is the tag after the name of a value, thus a reactjs component can set data in two different keys (ex : equipType1, equipType2)
     */
    constructor(props: {band: number, bandItem?: string}) {
        super(props);
    }

    /**
     * Returns a string with a suffix tag to split the component output (ex : equipType1, equipType2)
     * @param key The name of your data
     * @returns 
     */
    getKeyValue(key: string) {
        return key+(this.props.bandItem == null ? "" : this.props.bandItem);
    }
}